import PROFILE_FIELD from "Constants/profileFields";

const SIGNUP_FIELDS = {
  ...PROFILE_FIELD,
  AGREEMENT: "agreement",
  REF_ID: "ref_id",
  CAPTCHA: "captcha",
};

export default SIGNUP_FIELDS;
